import { Routes } from "@angular/router";
import { IntentResolverComponent } from "./components";

export const routes: Routes = [
    { path: "intent/:mime/:action/:data", component: IntentResolverComponent }
];
